import { render } from "./AdminSSE.vue?vue&type=template&id=1a90e980"
import script from "./AdminSSE.vue?vue&type=script&lang=js"
export * from "./AdminSSE.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__